import React, { useContext, useEffect, useState } from "react";
import { Avatar, Divider } from "antd";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

/* CUSTOM COMPONENTS */
import { BurgerButton, Container, Email, Title } from "./HeaderStyle";
import { s3_cdn } from "../../utils";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  MailOutlined,
} from "@ant-design/icons";
import HeaderContext from "../../context/HeaderContext";

const Header = (props) => {
  // varibles
  // const { SubMenu } = Menu;
  const { getDoctorDetailState } = props;
  const [doctor, setDoctor] = useState({
    profile_picture: "",
  });
  const location = useLocation();
  const { title, setTitle } = useContext(HeaderContext);

  useEffect(() => {
    if (getDoctorDetailState.apiState === "success") {
      setDoctor({
        ["profile_picture"]: getDoctorDetailState.data.profile_picture
          ? `${s3_cdn()}doctor/${getDoctorDetailState.data.profile_picture}`
          : getDoctorDetailState.data.gender == "female"
          ? "images/svg/avatar_female.svg"
          : getDoctorDetailState.data.gender == "male"
          ? "images/svg/avatar_male.svg"
          : "images/svg/avatar_transgender.svg",
      });
    }
  }, [getDoctorDetailState]);

  // useEffect(() => {
  //   console.log("Location changed", location);
  //   switch (location.pathname) {
  //     case "/":
  //       return setTitle("Dashboard");
  //     case "/appointment":
  //       return setTitle("Upcoming bookings");
  //     case "/appointment/save":
  //       return setTitle("Book Consultation for Patient");
  //     case "/schedule":
  //       return setTitle("Manage Schedule");
  //     case "/patient":
  //       return setTitle("Patients");
  //     case "/article-read":
  //       return setTitle("Read Blogs");
  //     case "/article-watch":
  //       return setTitle("Watch Video");
  //     case "/article-listen":
  //       return setTitle("Listen Audio");
  //     case "/emeregency-dtrf":
  //       return setTitle("Emergency DTRF");
  //     case "/emeregency-dtrf/dashboard":
  //       return setTitle("Emergency DTRF Dashboard");
  //     case "/dtrfs":
  //       return setTitle("DTRF Dashboard");
  //     case "/dtrf-form":
  //       return setTitle("Request/Order Test");
  //     case "/reports":
  //       return setTitle("Test Reports");
  //     case "/test-book":
  //       return setTitle("Test Directory");
  //     case "/Test":
  //       return setTitle("Test");
  //     case "/Testimonial":
  //       return setTitle("Reviews");
  //     case "/BookmarkedArticles":
  //       return setTitle("Bookmarks");
  //     case "/ProfileSetting":
  //       return setTitle("Profile");
  //     case "/QuickSupport":
  //       return setTitle("Quick Support");
  //     default:
  //       if (location.pathname.includes("/article-detail")) {
  //         return setTitle("Article details");
  //       } else if (location.pathname.includes("/patient/edit")) {
  //         return setTitle("Patient Edit");
  //       } else if (location.pathname.includes("/consultationview/")) {
  //         return setTitle("Consultation");
  //       }
  //       return setTitle("Dashboard");
  //   }
  // }, [location]);

  return (
    <Container>
      <BurgerButton>
        {props.collapsed ? (
          <MenuUnfoldOutlined
            className="trigger"
            onClick={() => props.toggle(!props.collapsed)}
          />
        ) : (
          <MenuFoldOutlined
            className="trigger"
            onClick={() => props.toggle(!props.collapsed)}
          />
        )}
      </BurgerButton>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Title>{title}</Title>
      </div>
      <div
        className="emailContainer"
        style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "right",
            flexDirection: "row",
            marginRight: 0,
            color: "#000",
          }}
        >
          {getDoctorDetailState.apiState === "success" && (
            <>
              <Email>
                {" "}
                <MailOutlined style={{ marginRight: "8px" }} />
                {getDoctorDetailState.data.email}
              </Email>
              <Divider style={{height:"auto"}} className="headerDivider" type="vertical" />
              <Avatar src={doctor.profile_picture} />
            </>
          )}
        </div>
      </div>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  getDoctorDetailState: state.getDoctorDetail,
});

export default connect(mapStateToProps, null)(Header);
